var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.label},on:{"input":function($event){return _vm.onChange()}},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})}
var staticRenderFns = []

export { render, staticRenderFns }